interface AttentionItem {
  key: string;
  label: string;
  count: number;
  filter?: string;
}

interface AttentionBarProps {
  items: AttentionItem[];
  activeFilter?: string;
  onFilter: (filter: string | undefined) => void;
}

export function AttentionBar({ items, activeFilter, onFilter }: AttentionBarProps) {
  const total = items.reduce((sum, i) => sum + i.count, 0);

  if (total === 0) return null;

  return (
    <div className="attention-bar">
      {items.map((item) => (
        <button
          type="button"
          key={item.key}
          aria-pressed={activeFilter === item.filter}
          className={`attention-item ${activeFilter === item.filter ? 'active' : ''} ${item.count > 0 ? 'has-count' : ''}`}
          onClick={() => onFilter(activeFilter === item.filter ? undefined : item.filter)}
          disabled={item.count === 0}
        >
          <span className="attention-count">{item.count}</span>
          <span className="attention-label">{item.label}</span>
        </button>
      ))}
      <style>{`
        .attention-bar {
          display: flex;
          gap: var(--space-sm);
          flex-wrap: wrap;
          margin-bottom: var(--space-lg);
        }
        .attention-item {
          display: flex;
          align-items: center;
          gap: var(--space-sm);
          padding: var(--space-sm) var(--space-md);
          background: var(--color-surface);
          border: 1px solid var(--color-border);
          border-radius: var(--radius-md);
          cursor: pointer;
          transition: border-color 0.15s, background 0.15s;
          font-size: 0.875rem;
        }
        .attention-item:disabled {
          opacity: 0.5;
          cursor: default;
        }
        .attention-item:not(:disabled):hover {
          border-color: var(--color-forest);
        }
        .attention-item.active {
          border-color: var(--color-forest);
          background: color-mix(in srgb, var(--color-forest) 8%, white);
        }
        .attention-item.has-count .attention-count {
          color: var(--color-urgent);
        }
        .attention-count {
          font-weight: 700;
          font-size: 1.125rem;
          min-width: 1.5rem;
        }
        .attention-label {
          color: var(--color-text-muted);
        }
      `}</style>
    </div>
  );
}
